module.exports = __webpack_public_path__ + "static/media/6841.d5a946d0.jpg";